import React, { Component } from "react";
import MetaTags from "react-meta-tags";
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import qs from "qs";

class AboutUs extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  constructor(){
		super()
		this.state = {  
			loading: false,
			setBalance : '',
			currentBalance : '',
			
		}
		
	}
  
  selectPlan(amount, event) {
    // console.log("Selected Amount:", amount);
    
    // console.log(localStorage)
    // console.log(localStorage.usertoken)
    

    // return false;
    if(localStorage.length>0 && localStorage.usertoken){

      let token = JSON.parse(localStorage.usertoken);
      // console.log(token.id)
      
      let formData = new FormData();
      formData.append('amount', amount)
      formData.append('id', token.id)
       
    //   axios.post("https://dropship.shopperr.in/api/pg/pay" , formData)
      axios.post("https://api.shopperr.in/pg/pay" , formData)
        .then(response => {
          // console.log(response)
          // console.log(response.data.redirectUrl)
          // window.location.href = response.data.redirectUrl
          let orderId = response.data.orderId;

          window.open(
            response.data.redirectUrl,
            '_blank' // <- This is what makes it open in a new window.
            );
          
        })
      

    }else{
      const redirectUrl = `${process.env.REACT_APP_URL}/login?redirecturl=${window.origin}/verify-login-merchant`;

      window.location.href = redirectUrl
    }
    // console.log(localStorage.userId);
}


  render() {
    return (
      <div className="wrapper">
          <h2 style={{"fontSize": "36px", "fontWeight": "bold", "textAlign": "center", "color": "#000"}}>Simple and Flexible Pricing</h2>
          <p style={{"fontSize": "16px", "textAlign": "center", "margin": "10px 0 30px 0", "color": "#000"}}>All accounts have access to the forever free Starter Plan.</p>
          
        <div className="container">
          <div className="row">
            <div className="col-lg-12" style={{lineHeight: "1.8"}}>
              <table width="100%" border="0" className="table table-hover table-bordered text-center">
                <thead>
                    <tr>
                        <td style={{"width":" 25%", "fontWeight": "bold", "color": "#7b999e", "textAlign": "left"}}>Plan name</td>
                        <td style={{"width":" 25%"}}>Starter</td>
                        <td style={{"width":" 25%"}}>Professional</td>
                        <td style={{"width":" 25%"}}>Premium</td>
                    </tr>
                    <tr>
                        <td style={{"width":" 25%", "fontWeight": "bold", "color": "#7b999e", "textAlign": "left"}}>Price</td>
                        <td style={{"width":" 25%"}}>Rs.499<i>/month</i></td>
                        <td style={{"width":" 25%"}}>Rs.1999<i>/month</i></td>
                        <td style={{"width":" 25%"}}>Rs.2999<i>/month</i></td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Product subscription
                            <span className="pricing-query-value">
                                <p className="query-explain">Maximum number of subscribed products</p>
                            </span>
                        </td>
                        <td>500</td>
                        <td>20000</td>
                        <td>Unlimited</td>
                    </tr>
                    <tr>
                        <td>Orders per month
                            <span className="pricing-query-value">
                                <p className="query-explain">Maximum number of orders we can fulfill for you every month</p>
                            </span>
                        </td>
                        <td>20</td>
                        <td>200</td>
                        <td>Unlimited</td>
                    </tr>
                    <tr>
                        <td>Product information export
                            <span className="pricing-query-value">
                                <p className="query-explain">Export subscribed product information</p>
                            </span>
                        </td>
                        <td><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                        <td><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                        <td><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                    </tr>
                    <tr>
                        <td>Autopay
                            <span className="pricing-query-value">
                                <i className="fa fa-question-circle-o" aria-hidden="true"></i>
                                <p className="query-explain">Automatically deduct money from E-wallet balance</p>
                            </span>
                        </td>
                        <td><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                        <td><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                        <td><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                    </tr>
                    <tr>
                        <td>Pricing automation
                            <span className="pricing-query-value">
                                <i className="fa fa-question-circle-o" aria-hidden="true"></i>
                                <p className="query-explain">Automatically set a percentage product price markup</p>
                            </span>
                        </td>
                        <td>&nbsp;</td>
                        <td><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                        <td><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                    </tr>
                    <tr>
                        <td>Marketplace API integration
                            <span className="pricing-query-value">
                                <i className="fa fa-question-circle-o" aria-hidden="true"></i>
                                <p className="query-explain">Automatically sync inventory, sync price, download orders, update order status, upload tracking numbers, etc.</p>
                            </span>
                        </td>
                        <td>&nbsp;</td>
                        <td><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                        <td><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                    </tr>
                    <tr>
                        <td>Sales report
                            <span className="pricing-query-value">
                                <i className="fa fa-question-circle-o" aria-hidden="true"></i>
                                <p className="query-explain">Comprehensive sales data and analysis</p>
                            </span>
                        </td>
                        <td>&nbsp;</td>
                        <td>Basic</td>
                        <td>Advanced</td>
                    </tr>
                    <tr>
                        <td>Product exclusiveness
                            <span className="pricing-query-value">
                                <i className="fa fa-question-circle-o" aria-hidden="true"></i>
                                <p className="query-explain">Pick any products to be available for you to resell exclusively. Buyout fee is Rs 2,000 /SKU/month. Please contact Customer Support for details.</p>
                            </span>
                        </td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                    </tr>
                    <tr>
                        <td>VIP Reward
                            <span className="pricing-query-value">
                                <i className="fa fa-question-circle-o" aria-hidden="true"></i>
                                <p className="query-explain">Cashback if you reach certain monthly order volume (case by case). Please contact Customer Support for details.</p>
                            </span>
                        </td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                    </tr>
                    <tr>
                        <td style={{"fontSize": "20px", "fontWeight":"bold", "color":"#7b999e"}}>Select plan</td> 
                        <td><input type="button" class="btn btn-modern" value="Select" onClick={(event) => this.selectPlan(1, event)} style={{"display": "inline-block", "padding": "7px 21px", "color": "#fff", "fontSize": "14px", "textTransform": "capitalize", "borderRadius": "4px", "backgroundColor": "#19489e"}} /></td>
                        <td><input type="button" class="btn btn-modern" value="Select" onClick={(event) => this.selectPlan(1999, event)} style={{"display": "inline-block", "padding": "7px 21px", "color": "#fff", "fontSize": "14px", "textTransform": "capitalize", "borderRadius": "4px", "backgroundColor": "#19489e"}}  /></td>
                        <td><input type="button" class="btn btn-modern" value="Select" onClick={(event) => this.selectPlan(2999, event)} style={{"display": "inline-block", "padding": "7px 21px", "color": "#fff", "fontSize": "14px", "textTransform": "capitalize", "borderRadius": "4px", "backgroundColor": "#19489e"}}  /></td>
                
                    </tr>
                </tbody>
            </table>
            </div>
				
          </div>
        </div>
      </div>
    );
  }
}

export default AboutUs;
